import { Grid, Typography } from '@mui/material';
import FieldText from '../../../../../components/general/fields/fieldText';
import { SarlaftFinancialProps } from './props';
import { useSarlaftFinancial } from './hook';

export const SarlaftFinancial = (props: SarlaftFinancialProps) => {
    const { formik } = useSarlaftFinancial(props);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12}>
                <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                    Información financiera
                </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Ingresos anuales"
                    name="annualIncome"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.annualIncome}
                    errors={formik.errors.annualIncome}
                    value={formik.values.annualIncome}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Activos"
                    name="assets"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.assets}
                    errors={formik.errors.assets}
                    value={formik.values.assets}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Egresos anuales"
                    name="annualExpenditure"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.annualExpenditure}
                    errors={formik.errors.annualExpenditure}
                    value={formik.values.annualExpenditure}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Pasivos"
                    name="liabilities"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.liabilities}
                    errors={formik.errors.liabilities}
                    value={formik.values.liabilities}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Otros anuales"
                    name="otherAnnualIncome"
                    size="small"
                    onBlur={formik.handleBlur}
                    value={formik.values.otherAnnualIncome}
                    onChange={formik.handleChange}
                    errors={formik.errors.otherAnnualIncome}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={12}>
                <FieldText
                    label="Concepto otros ingresos"
                    name="otherIncome"
                    rows={4}
                    onBlur={formik.handleBlur}
                    value={formik.values.otherIncome}
                    onChange={formik.handleChange}
                    errors={formik.errors.otherIncome}
                />
            </Grid>
        </Grid>
    );
};
